import { render, staticRenderFns } from "./ZTabs.vue?vue&type=template&id=404facac&"
import script from "./ZTabs.vue?vue&type=script&lang=js&"
export * from "./ZTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports